<button type="button" id="chooseTeamsModalButton" class="btn btn-primary" data-bs-toggle="modal" hidden
        data-bs-target="#chooseTeamsModal">
</button>  
  <!-- Modal -->
<div class="modal fade" id="chooseTeamsModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content content-box">
        <div class="modal-header choose-teams-header">
            <img (click)="closeModal()" src="assets/svg/close-button.svg" id="closeModal" alt="X" data-bs-dismiss="modal"
             aria-label="Close" class="close-btn">
        </div>
        <div class="modal-body choose-teams-body">
            <h2 class="modal-title">{{'custom_poll_assign_modal_title' | translate}}</h2>
            <div class="d-flex align-items-center mb-5">
              <input class="team-check" type="checkbox" [checked]="isAllTeams" [indeterminate]="!isAllTeams && teamsForm.value.teams.length > 0" (change)="selectAllTeams($event)">
              <span class="select-all">{{'custom_poll_assign_modal_select_all' | translate}}</span>
            </div>
            <form class="team-form-container" [formGroup]="teamsForm">
                <div class="team-container" *ngFor="let team of teamsToChoose, let index = index">
                    <input class="team-check" type="checkbox" [id]="'team-check-' + index" [checked]="selectedTeams[index]" (change)="onChange(team.uuid, $event)">
                    <label class="team-name" [attr.for]="'team-check-' + index" [pTooltip]="team.name" tooltipPosition="bottom" tooltipStyleClass="response-distribution-tooltip">{{team.name}}</label>
                </div>
            </form>
        </div>
        <div class="modal-footer choose-teams-footer">
            <button class="assign-btn" pButton type="button" [disabled]="teamsForm.value.teams.length === 0" (click)="assignTeams()" label="{{fromGeneral ? ('custom_poll_assign_modal_confirm_btn' | translate):('step2_choice2_confirm' | translate)}}"></button>
        </div>
      </div>
    </div>
</div>